import { observable, makeObservable } from 'mobx';
import { CouponIdType } from './coupons';
import { EventsListMarkets } from './EventsListMarkets';
import { Common } from 'src/domains/common/Common';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';

export class EventsListSelectTabState {
    @observable public filter_coupon: CouponIdType = 'all';
    public readonly eventsListMarkets: EventsListMarkets;

    public constructor(private readonly common: Common) {
        makeObservable(this);
        this.eventsListMarkets = new EventsListMarkets(LanguagesState.get(this.common).getTranslation);
    }
}
